import { customButtonDefault } from '@modules/edit';
import { FeatureType, type STMapMarker, STMapMarkerType } from '@types';
import { stEditorAmap } from '../STAMap';
import { MARKER_ICON_DEFAULT, MARKER_TITLE_DEFAULT } from '../constants';
import { newMarkerId } from '../utils/newMarkerId';

export function generateMarkerData(type: STMapMarkerType): STMapMarker {
  const pos = stEditorAmap.getCenter();
  if (!pos) throw new Error('地图未加载完成');
  const id = newMarkerId();
  switch (type) {
    case STMapMarkerType.scene:
      return {
        type: STMapMarkerType.scene,
        id,
        title: '',
        showTitle: 1,
        titleSetting: MARKER_TITLE_DEFAULT,
        icon: {
          type: 0,
          lng: pos.lng,
          lat: pos.lat,
          showRadar: 1,
          scaleX: 1,
          scaleY: 1,
          ...MARKER_ICON_DEFAULT,
        },
        data: { type: 0 },
      };
    case STMapMarkerType.point:
      return {
        type: STMapMarkerType.point,
        id,
        title: '',
        showTitle: 1,
        titleSetting: MARKER_TITLE_DEFAULT,
        icon: {
          type: 0,
          lng: pos.lng,
          lat: pos.lat,
          showRadar: 0,
          scaleX: 1,
          scaleY: 1,
          ...MARKER_ICON_DEFAULT,
        },
        data: customButtonDefault(FeatureType.noFunc),
      };
    case STMapMarkerType.text:
      return {
        type: STMapMarkerType.text,
        id,
        title: '',
        titleSetting: MARKER_TITLE_DEFAULT,
        icon: {
          lng: pos.lng,
          lat: pos.lat,
          zoom: pos.zoom,
          stick: 0,
        },
        data: customButtonDefault(FeatureType.noFunc),
      };
    case STMapMarkerType.image:
      return {
        type: STMapMarkerType.image,
        id,
        title: '',
        icon: {
          lng: pos.lng,
          lat: pos.lat,
          zoom: pos.zoom,
          scaleX: 1,
          scaleY: 1,
          image: {
            type: 0,
            id: 0,
            url: '',
          },
        },
        data: customButtonDefault(FeatureType.noFunc),
      };
    case STMapMarkerType.polyline:
      return {
        type: STMapMarkerType.polyline,
        id,
        title: '',
        icon: {
          path: [],
          strokeStyle: {
            type: 'solid',
            color: '#286EFA',
            width: 2,
            opacity: 1,
          },
          borderStyle: {
            color: '#1A1A1A',
            width: 0,
          },
          animation: {
            type: 0,
            markerIcon: '',
            markerWidth: 0,
            markerHeight: 0,
            markerScale: 0.5,
          },
        },
        data: customButtonDefault(FeatureType.noFunc),
      };
    case STMapMarkerType.pulse:
      return {
        type: STMapMarkerType.pulse,
        id,
        title: '',
        icon: {
          path: [],
          pulseStyle: {
            headColor: '#286EFA',
            headOpacity: 1,
            tailColor: '#D6E4EF',
            tailOpacity: 1,
            width: 2,
          },
          animation: {
            type: 0,
            markerIcon: '',
            markerWidth: 0,
            markerHeight: 0,
            markerScale: 0.5,
          },
        },
      };
    case STMapMarkerType.circle: {
      const { zoom } = stEditorAmap.getCenter();
      const radiusScale = stEditorAmap.getZoomScale({
        zoom,
        baseZoom: 8.74,
      });
      const radius = Math.round(12000 / radiusScale);
      return {
        type: STMapMarkerType.circle,
        id,
        title: '',
        icon: {
          lng: pos.lng,
          lat: pos.lat,
          radius: radius,
          blink: 0,
          fillStyle: {
            color: '#286EFA',
            opacity: 0.2,
          },
          borderStyle: {
            color: '#286EFA',
            opacity: 1,
            width: 2,
          },
          fillStyleActive: {
            color: '#286EFA',
            opacity: 0.5,
          },
          borderStyleActive: {
            color: '#286EFA',
            opacity: 1,
            width: 2,
          },
        },
        data: customButtonDefault(FeatureType.noFunc),
      };
    }
    case STMapMarkerType.polygon:
      return {
        type: STMapMarkerType.polygon,
        id,
        title: '',
        icon: {
          path: [],
          blink: 0,
          fillStyle: {
            color: '#286EFA',
            opacity: 0.2,
          },
          borderStyle: {
            color: '#286EFA',
            opacity: 1,
            width: 2,
          },
          fillStyleActive: {
            color: '#286EFA',
            opacity: 0.5,
          },
          borderStyleActive: {
            color: '#286EFA',
            opacity: 1,
            width: 2,
          },
          animation: {
            type: 0,
            markerIcon: '',
            markerWidth: 0,
            markerHeight: 0,
            markerScale: 0.5,
          },
        },
        data: customButtonDefault(FeatureType.noFunc),
      };
    default:
      throw new Error('未知标记类型');
  }
}
